<template>
  <form @submit.prevent="submit">
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="modal-card-title">
          <p class="has-text-weight-bold title is-4">Reject Date Change</p>
        </div>
      </header>
      <section class="modal-card-body">
        <b-field label="Reason">
          <b-input type="textarea" v-model="reason" />
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          Cancel
        </button>
        <button :class="`button is-danger ${loading ? 'is-loading' : ''}`">
          Reject
        </button>
      </footer>
    </div>
  </form>
</template>

<script>
import { OrderService } from "@/services/order.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  orderService: OrderService,
  props: {
    orderId: {
      type: String,
      required: true
    },
    type: {
      validator: value => {
        return ["start", "finish"].indexOf(value) !== -1;
      },
      required: true
    }
  },
  data: () => ({
    reason: "",
    loading: false
  }),
  methods: {
    async submit() {
      this.loading = true;

      try {
        const order = await this.$options.orderService
          .rejectDateChange(this.orderId, {
            startOrFinish: this.type,
            reason: this.reason,
            includes: "dateChangeLogs"
          })
          .then(response => JsonDenormalizer.denormalize(response.data));

        this.$buefy.toast.open({
          message: "Date change request has been rejected.",
          type: "is-info",
          position: "is-top-right"
        });

        this.$emit("submit", order);
        this.$parent.close();
      } catch (err) {}

      this.loading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderKpi/OrderKpiDateChangeModalReject.vue